import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CountryService } from '../country.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { ICountriesDto } from 'src/app/models/backend';
import { take } from 'rxjs';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-edit-country',
  templateUrl: './edit-country.component.html',
  styleUrls: ['./edit-country.component.scss']
})
export class EditCountryComponent {
  errors: string[] | null = [];
  countriesForm: FormGroup;
  country: ICountriesDto

  constructor(public activeModal: NgbActiveModal,
    private fb: FormBuilder, public countryService: CountryService,
    public router: Router,
    private toastr: ToastrService
  ) {
    console.log(this.countryService.id)
    if (this.countryService.id == null || this.countryService.id == undefined) {
      this.router.navigateByUrl("countries")
    }
  }
  ngOnInit(): void {
    this.countryService.GetCountry(this.countryService.id)
      .pipe(take(1))
      .subscribe({

        next: r => this.SetValuetoForm(r),
        error: e =>{
          if (e.error.message) {
            this.toastr.error('Oops!', e.error.message);
          }
          else {
            this.toastr.error('Oops!', "Something went wrong");
          }
        }
      })
  }
  SetValuetoForm(country: ICountriesDto) {
    this.countryService.id = null
    console.log(country)
    this.countriesForm = this.fb.group({
      Id: [country.id, [Validators.required]],
      Name: [country.name, [Validators.required, Validators.maxLength(100)]],
      ZipCode: [country.zipCode, [Validators.required, Validators.maxLength(10)]],
      PhoneCode: [country.phoneCode, [Validators.required, Validators.maxLength(10)]]
    });
  }

  onSubmit() {
    this.errors = [];
    if (!this.countriesForm.valid) return this.countriesForm.markAllAsTouched();
    if (this.errors.length > 0) return;

    this.countryService.updateCountry(this.countriesForm.value)
      .subscribe({
        next: r => {
          // Swal.fire('Updated', '', 'success')
          this.toastr.success('Updated', "Record Updated");
          this.activeModal.close({ refresh: true });
        },
        error: e => {
          this.errors = e.error?.errors || [e.error?.message]
          if (e.error.message) {
            this.toastr.error('Oops!', e.error.message);
          }
          else {
            this.toastr.error('Oops!', "Something went wrong");
          }
        }
      })
  }
  cancel() {
    this.countryService.id = null
    this.router.navigateByUrl("countries")
  }
}
